export const inspectTable = [
  {
    id: 1,
    title: "MSDS 게시 (법 제114조 제1항)",
    content: "작업장에 MSDS를 적절한 장소에 게시·비치하였는가?\n\n" +
      "※ MSDS 게시장소 (택 1)\n" +
      " ① 대상물질을 취급하는 작업공정이 있는 장소\n" +
      " ② 작업장 내 근로자가 가장 보기 쉬운 장소\n" +
      " ③ 근로자가 작업 중 쉽게 접근할 수 있는 전산장비",
    isChecked: "",
  },
  {
    id: 2,
    title: "MSDS 교육 (법 제114조제3항)",
    content: "취급근로자에게 MSDS 교육(1시간)을 실시하였는가?\n\n" +
      "※ ① 화학물질을 제조·사용·운반·저장하는 작업에 근로자를 신규로 배치하게 된 경우,\n" +
      "&nbsp;&nbsp;&nbsp; ② 새로운 화학물질이 도입된 경우, \n" +
      "&nbsp;&nbsp;&nbsp; ③ 유해·위험성 정보가 변경된 경우 실시",
    isChecked: "",
  },
  {
    id: 3,
    title: "MSDS 교육 (법 제114조제3항)",
    content: "MSDS 교육내용은 아래의 내용을 모두 포함하였는가?\n\n" +
      "※ 화학물질의 명칭 또는 제품명, 물리적 위험성 및 건강 유해성, 취급상의 주의사항, 적절한 보호구, 응급조치요령, 사고 시 대처방법, MSDS 및 경고표지의 이해방법",
    isChecked: "",
  },
  {
    id: 4,
    title: "MSDS 교육 (법 제114조제3항)",
    content: "MSDS 교육시간 및 내용을 기록하고 보존하였는가?",
    isChecked: "",
  },
  {
    id: 5,
    title: "경고표지 (법 제115조)",
    content: "화학물질을 담은 소분용기에 경고표지를 부착하였는가?",
    isChecked: "",
  },
  {
    id: 6,
    title: "경고표지 (법 제115조)",
    content: "경고표지 기재내용은 아래 내용을 모두 포함하였는가?\n\n" +
      "※ 명칭, 그림문자, 신호어, 유해‧위험성 문구, 예방조치 문구, 공급자 정보",
    isChecked: "",
  },
  {
    id: 7,
    title: "특별관리물질관리 (안전보건규칙 제439조)",
    content: "특별관리물질 고지를 적절한 장소에 게시 하였는가?",
    isChecked: "",
  },
  {
    id: 8,
    title: "특별관리물질관리 (안전보건규칙 제439조)",
    content: "취급근로자에게 특별교육(16시간)을 실시하였는가?",
    isChecked: "",
  },
  {
    id: 9,
    title: "특별관리물질관리 (안전보건규칙 제439조)",
    content: "특별관리물질 사용시 취급일지를 적절하게 작성하였는가?",
    isChecked: "",
  },
];
